"use client";

import { Info } from "lucide-react";
import { useTranslations } from "next-intl"


/**
 * Informational note rendered below the Shopify Tools grid. Explains that the
 * Catalog Search and Policies & FAQs tools pull live data from Shopify on
 * every request — users do NOT need to mirror product or policy content into
 * their knowledge base for those tools to work.
 *
 * Also warns about the knowledge-base overlap pitfall: if the KB already
 * contains product/policy content, enabling both sources means the AI sees
 * both simultaneously and can produce conflicting answers.
 */
export function ShopifyLiveDataNote() {
  const tUi = useTranslations("AgentTools.AgentsSharedShopifyLiveDataNote")

  return (
    <div className="flex gap-2 p-2.5 rounded-md border border-sky-200 bg-sky-50 text-[11px] leading-snug text-sky-900">
      <Info className="w-3.5 h-3.5 text-sky-600 shrink-0 mt-[1px]" />
      <div className="space-y-1">
        <p>
          <span className="font-semibold"><span key={tUi("catalogSearch")}>{tUi("catalogSearch")}</span></span> <span><span key={tUi("and")}>{tUi("and")}</span></span>{" "}
          <span className="font-semibold"><span key={tUi("policiesFAQs")}>{tUi("policiesFAQs")}</span></span> <span><span key={tUi("fetchLiveDataFromYourShopifyStoreOn")}>{tUi("fetchLiveDataFromYourShopifyStoreOn")}</span></span>
        </p>
        <p className="text-sky-800">
          <span className="font-semibold"><span key={tUi("headsUp")}>{tUi("headsUp")}</span></span> <span><span key={tUi("ifYourKnowledgeBaseAlreadyContainsProductOr")}>{tUi("ifYourKnowledgeBaseAlreadyContainsProductOr")}</span></span>
        </p>
      </div>
    </div>
  );
}
